import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { AnimalSale } from '../../components/animalsale/ui/index';
// import {Apps} from '~/features/apps';
// import {AppHeader} from '~/widgets/ui';
// import {withTariff} from '~/shared/lib/hoc/with-tariff';
// import compose from 'compose-function';
// Приложения страница
const AnimalSalePage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Реализация</title>
            </Helmet>
            <AnimalSale/>
            {/* <AppHeader title={t('apps')} /> */}
            {/* <Apps /> */}
        </>
    );
};

export default AnimalSalePage
